@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.bulk-other-shipping-options {
  min-height: 600px;
}

.header {
  font-size: 22px;
  font-weight: @bold;
  border-bottom: 1px solid @bulk-edit--header--background-color;
  display: flex;
  padding: 10px 0;
  align-items: center;
}

.logo {
  margin-right: 10px;
  width: 50px;
}

.header-title {
  margin-right: 10px;
}
